import {Routes} from '@angular/router';
import {CitizenLayoutComponent} from './components/layout/citizen-layout/citizen-layout.component';

export const routes: Routes = [{
  path: '',
  component: CitizenLayoutComponent,
  loadChildren: ()=> import("./pages/citizen/citizen.routes").then(({citizenRoutes})=> citizenRoutes)
}]
